
<div
    [ngStyle]="{'background-image': 'url('+src+')','background-position': '50% 50%','background-repeat': 'no-repeat no-repeat','height':height,'width':width}">
</div>